import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { ALL_SEAT_INDEXES } from '../../../../types/pokerTypes';
import { isTestEnvironment } from '../../../../utils/utils';
import { BetPotDisplayContainer } from './betPotDisplayContainer';
const PIXI_DATA = isTestEnvironment() ? { type: 'bet-pots-container' } : null;
export const BetPotsContainer = () => {
    return (_jsx(Container, { "pixi-data": PIXI_DATA, interactiveChildren: false, children: ALL_SEAT_INDEXES.map((seatIndex) => (_jsx(BetPotDisplayContainer, { seatIndex: seatIndex }, seatIndex))) }));
};
